export default __webpack_public_path__ + "static/media/typePlane.67cbf2ef.svg";